<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update'
  },
  props: {
    label: {
      type: String,
      default: null
    }
  }
}
</script>

<template>
  <div
    class="base-question-textarea"
    style="
      position: relative;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
    "
  >
    <div
      v-if="label"
      class='input-label'
      style="
        text-align: left;
        margin-bottom: 8px;
        width: 100%;
      "
    >
      <label
        style="
          color: #333;
          font-weight: bold;
          position: relative;
        "
      >
        {{ label }}
      </label>
    </div>

    <md-field>
      <md-textarea
        v-bind="$attrs"
        v-on="$listeners"
        @input="$emit('update', $event)"
      />
    </md-field>
  </div>
</template>

<style lang="scss">
  .base-question-textarea {
    .md-field {
      margin: 0 !important;
      padding: 0 !important;
    }

    .md-field.md-has-textarea:not(.md-autogrow):after, .md-field.md-has-textarea:not(.md-autogrow):before {
      // box-shadow: none !important;
      border: 1px solid transparent !important;
    }

    textarea {
      background: rgba(0, 0, 0, 0.05) !important;
      border-radius: 5px !important;
    }
  }
</style>
